import React from "react";
import { ClusterEvalModel } from "../Models/ClusterEvalModel";
import { DataHelper } from "../Helpers/DataHelper";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { StudyModel } from "../Models/StudyModel";
import { EvalFlowCriteria } from "../Models/EvalFlowCriteria";
import { ImageWithSVGPoints } from "./ImageWithPoints";

export class AICurveEvalButton extends React.Component<
    {
        evaluationResult?: ClusterEvalModel,
        dataHelper: DataHelper,
        rowData: PreviewMeasurement,
        studySelected: StudyModel,
        procedureId: string,
        onEvaluationResult: (resultDict: ClusterEvalModel) => void,
        scrollPositionInDatapoints?: number,
        axisSizeInDatapoints?: number
    },
    {
        evaluationResult?: ClusterEvalModel,
        modelsAvailable?: string[],
        modelSelected?: string,
        resultsloaded: boolean,
        loading: boolean
    }
> {

    

    constructor(props: any) {
        super(props);
        let initResult=undefined
        if(this.props.evaluationResult){initResult = this.props.evaluationResult}
        this.state = {
            evaluationResult:initResult,
            resultsloaded: false,
            loading: false
        }
       this.canvasRef = React.createRef<HTMLCanvasElement>();
       this.flowcanvasRef = React.createRef<HTMLCanvasElement>();
       this.processedflowcanvasRef = React.createRef<HTMLCanvasElement>();
    }

    static defaultProps = {
        evaluationResult: null
      }



    evalElement(): JSX.Element {
        const result = this.state.evaluationResult
        const evalCriteria = new EvalFlowCriteria()



        
        if (!result) {
          return <div>NA</div>;
        }
    
        const getBackgroundColor = (value:number, label:string) => {
            const evalMetrics= evalCriteria.getCriteria(label)

            if (value < 0) return "#969696"; // Gray for invalid/unset values;

            if (evalMetrics?.smallerThanGood) {
                if (value <= evalMetrics.lowerBound) return "#4CAF50"; // Green
                if (value <= evalMetrics.upperBound) return "#FFEB3B"; // Yellow
                return "#F44336"; // Red
            } else if(evalMetrics) {
                if (value >= evalMetrics.upperBound) return "#4CAF50"; // Green
                if (value >= evalMetrics.lowerBound) return "#FFEB3B"; // Yellow
                return "#F44336"; // Red
            }

            return "#969696"; // Gray for unknown labels
            
        };
    
        const getTextColor = (backgroundColor:string) => {
          return backgroundColor === "#FFEB3B" ? "black" : "white";
        };

        const renderEmbeddingSquare = (): JSX.Element => {
          return (
            <div className="aiFlowAnalysisSquare">
              {result.newEmbedding.map((value, index) => (
                <div key={index} className="aiFlowEvalCellEm"><div>x: {value[0].toFixed(2)}</div><div>y: {value[1].toFixed(2)}</div></div>
              ))}
            </div>
          );
        };

        const renderClustersSquare = (): JSX.Element => {
          return (
            <div className="aiFlowAnalysisSquare">
              {result.clusters.map((value, index) => (
                <div key={"cluster_"+index} className="aiFlowEvalCellEm"><div>{value}</div></div>
              ))}
            </div>
          );
        };
    
        const renderCell = (value: number, label: string) => {
          const backgroundColor = getBackgroundColor(value, label);
          const textColor = getTextColor(backgroundColor);
          
          return (
            <div className="aiFlowEvalCell" style={{
              backgroundColor,
              color: textColor,
            }}>
              <span>{label}:</span>
              <span>{value>=0 ? typeof value === 'number' ? value.toFixed(2) : value : "NA"}</span>
            </div>
          );
        };

    
    
        return (
          <div>
            <table className="tableStyle">
              <tbody>
                <tr>
                  <td className="cellStyle">{renderCell(result.fromCentre, 'From Centre')}</td>
                </tr>
                <tr>
                  <td className="cellStyle">{renderCell(result.distanceMean, 'Distance Mean')}</td>
                </tr>
                <tr>
                  <td className="cellStyle">{renderCell(result.distanceMedian, 'Distance Median')}</td>
                </tr>
                <tr>
                  <td className="cellStyle">{renderCell(result.clusterConsistency, 'Cluster Consistency')}</td>
                </tr>
                <tr>
                  <td className="cellStyle">{renderCell(result.clusterRating, 'Cluster Rating')}</td>
                </tr>

                <tr>
                  <div className="embeddingHolder">
                    <h4 className="embeddingHeader">New Embedding:</h4>
                    {renderEmbeddingSquare()}
                 </div>
                </tr>
                <tr>
                  <div className="embeddingHolder">
                    <h4 className="embeddingHeader">Clusters:</h4>
                    {renderClustersSquare()}
                 </div>
                </tr>
                <tr>
                  <ImageWithSVGPoints imageSrc="/umap_fftOptimalSplit_fix_2_20_full.png" imageWidth={400} imageHeight={300} points={this.props.evaluationResult?.newEmbedding} onPointClick={(point, index)=>{
                    alert("You Pressed Curve Segment: "+index)
                  }} graphAxisLengthUnits={[22,20]} graphCenterPixls={[75,260]}  scalePoints={true} graphSizePixls={[250,230]}></ImageWithSVGPoints>
                </tr>
              </tbody>
            </table>
            
          </div>
        );
      }


     drawEmbeddingPlot = (data: any, flowpoint: any) => {
        const canvas = this.canvasRef.current;
        if (!canvas || !data) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        const width = canvas.width;
        const height = canvas.height;
        const padding = 40;

        let points: { x: number; y: number; cluster: number; id: string}[] = [];

        if (data) {
            Object.entries(data).forEach(([key, value]: [string, any]) => {
                if (value && value.embedding_position && value.cluster_label !== undefined) {
                    const [x, y] = value.embedding_position;

                    if (typeof x === 'number' && typeof y === 'number') {
                        points.push({
                            x: x,
                            y: y,
                            cluster: value.cluster_label,
                            id: key
                        });
                    }
                }
            });
        }
        
        if (points.length === 0) return;
       
        const xValues = points.map(p => p.x);
        const yValues = points.map(p => p.y);
        const xMin = Math.min(...xValues);
        const xMax = Math.max(...xValues);
        const yMin = Math.min(...yValues);
        const yMax = Math.max(...yValues);
      
        const scaleX = (width - 2 * padding) / (xMax - xMin);
        const scaleY = (height - 2 * padding) / (yMax - yMin);
        

    const colors = ['#F5812E', '#45BCB4', '#9FB6E8', '#91837A', '#F2C94C', '#7FC29B', '#E6E0D8', '#D99A6C', '#B7C9E2', '#D6D96F', '#E3B6CC', '#9FA1A4']
;
        
        ctx.strokeStyle = '#e5e7eb';
        ctx.lineWidth = 1;
      
        for (let i = 0; i <= 10; i++) {
            const x = padding + (i / 10) * (width - 2 * padding);
            ctx.beginPath();
            ctx.moveTo(x, padding);
            ctx.lineTo(x, height - padding);
            ctx.stroke();
        }
        
        for (let i = 0; i <= 10; i++) {
            const y = padding + (i / 10) * (height - 2 * padding);
            ctx.beginPath();
            ctx.moveTo(padding, y);
            ctx.lineTo(width - padding, y);
            ctx.stroke();
        }
        
        ctx.strokeStyle = '#374151';
        ctx.lineWidth = 2;
        
        ctx.beginPath();
        ctx.moveTo(padding, height - padding);
        ctx.lineTo(width - padding, height - padding);
        ctx.stroke();
        
        ctx.beginPath();
        ctx.moveTo(padding, padding);
        ctx.lineTo(padding, height - padding);
        ctx.stroke();
        
        points.forEach(point => {
            const x = padding + (point.x - xMin) * scaleX;
            const y = height - padding - (point.y - yMin) * scaleY;

            const color = colors[point.cluster % colors.length];

            const isHovered = false; // Implement hover logic if needed
            if (color !== 'none')
            {
            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, isHovered ? 6 : 4, 0, 2 * Math.PI);
            ctx.fill();
            
            ctx.strokeStyle = isHovered ? '#000000' : '#ffffff';
            ctx.lineWidth = isHovered ? 2 : 1;
            ctx.stroke();
            
            if (isHovered) {
                ctx.strokeStyle = color;
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.arc(x, y, 10, 0, 2 * Math.PI);
                ctx.stroke();
            }
        }
        });

        if (flowpoint && flowpoint.length > 0) {
         const [pointx, pointy] = flowpoint[0];
         const x = padding + (pointx - xMin) * scaleX;
            const y = height - padding - (pointy - yMin) * scaleY;

            const color = "red"

            const isHovered = true; // Implement hover logic if needed

            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, isHovered ? 6 : 4, 0, 2 * Math.PI);
            ctx.fill();
            
            ctx.strokeStyle = isHovered ? '#000000' : '#ffffff';
            ctx.lineWidth = isHovered ? 2 : 1;
            ctx.stroke();
            
            if (isHovered) {
                ctx.strokeStyle = color;
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.arc(x, y, 10, 0, 2 * Math.PI);
                ctx.stroke();
            }
        
        }

        
        ctx.fillStyle = '#374151';
        ctx.font = '14px sans-serif';
        ctx.textAlign = 'center';
        
        ctx.fillText(' Component 1', width / 2, height - 10);
        
        ctx.save();
        ctx.translate(15, height / 2);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(' Component 2', 0, 0);
        ctx.restore();
    };

    drawFlowPlot = (canvas: HTMLCanvasElement, data: any, segmenting: any) => {

        const width = 500;
        const height = 200;
      
        if (!canvas || !data.BLUE || data.BLUE.length === 0) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Canvas dimensions
        const padding = 20;
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;

        // Find min/max values for scaling
        const minValue = Math.min(...data.BLUE);
        const maxValue = Math.max(...data.BLUE);
        const valueRange = maxValue - minValue;

        // Draw background
        ctx.fillStyle = '#f9fafb';
        ctx.fillRect(0, 0, width, height);

        // Draw grid
        ctx.strokeStyle = '#e5e7eb';
        ctx.lineWidth = 1;

        // Horizontal grid lines
        for (let i = 0; i <= 5; i++) {
            const y = padding + (i / 5) * plotHeight;
            ctx.beginPath();
            ctx.moveTo(padding, y);
            ctx.lineTo(width - padding, y);
            ctx.stroke();
        }

        // Vertical grid lines (every 10% of data points)
        for (let i = 0; i <= 10; i++) {
            const x = padding + (i / 10) * plotWidth;
            ctx.beginPath();
            ctx.moveTo(x, padding);
            ctx.lineTo(x, height - padding);
            ctx.stroke();
        }

        // Draw axes
        ctx.strokeStyle = '#374151';
        ctx.lineWidth = 2;

        // X-axis
        ctx.beginPath();
        ctx.moveTo(padding, height - padding);
        ctx.lineTo(width - padding, height - padding);
        ctx.stroke();

        // Y-axis
        ctx.beginPath();
        ctx.moveTo(padding, padding);
        ctx.lineTo(padding, height - padding);
        ctx.stroke();

        // Draw horizontal line at y=0 if 0 is within the value range
        if (minValue <= 0 && maxValue >= 0) {
            ctx.save();
            ctx.strokeStyle = '#9ca3af'; // gray-400
            ctx.lineWidth = 1.5;
            ctx.setLineDash([4, 4]);
            const zeroY = height - padding - ((0 - minValue) / valueRange) * plotHeight;
            ctx.beginPath();
            ctx.moveTo(padding, zeroY);
            ctx.lineTo(width - padding, zeroY);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.restore();
        }

        // Draw the flow line
        if (data.BLUE.length > 1) {
            ctx.strokeStyle = '#3b82f6';
            ctx.lineWidth = 2;
            ctx.beginPath();

            // Plot each point
            data.BLUE.forEach((value:any, index: number) => {
                const x = padding + (index / (data.BLUE.length - 1)) * plotWidth;
                const y = height - padding - ((value - minValue) / valueRange) * plotHeight;
                
                if (index === 0) {
                    ctx.moveTo(x, y);
                } else {
                    ctx.lineTo(x, y);
                }
            });

            ctx.stroke();

            // Draw points
            ctx.fillStyle = '#3b82f6';
            data.BLUE.forEach((value:any, index: number) => {
                if (index % Math.ceil(data.BLUE.length / 50) === 0) { // Show every nth point to avoid overcrowding
                    const x = padding + (index / (data.BLUE.length - 1)) * plotWidth;
                    const y = height - padding - ((value - minValue) / valueRange) * plotHeight;
                    
                    ctx.beginPath();
                    ctx.arc(x, y, 2, 0, 2 * Math.PI);
                    ctx.fill();
                }
            });
        }

        // Draw segmenting lines if provided
        if (segmenting) {
            ctx.strokeStyle = '#ef4444'; // Red color for segment boundaries
            ctx.lineWidth = 2;
            ctx.setLineDash([5, 5]); // Dashed line pattern

            segmenting.forEach((segment: any) => {
                // Draw vertical line at segment start
                const startX = padding + (segment.start / (data.BLUE.length - 1)) * plotWidth;
                ctx.beginPath();
                ctx.moveTo(startX, padding);
                ctx.lineTo(startX, height - padding);
                ctx.stroke();

                // Draw vertical line at segment end
                const endX = padding + (segment.end / (data.BLUE.length - 1)) * plotWidth;
                ctx.beginPath();
                ctx.moveTo(endX, padding);
                ctx.lineTo(endX, height - padding);
                ctx.stroke();
            });

            // Reset line dash for other elements
            ctx.setLineDash([]);
        }

        // Draw axis labels
        ctx.fillStyle = '#374151';
        ctx.font = '12px sans-serif';
        ctx.textAlign = 'center';

        // X-axis label
        ctx.fillText('Time', width / 2, height - 5);

        // Y-axis label
        ctx.save();
        ctx.translate(10, height / 2);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText('Value', 0, 0);
        ctx.restore();

        // Draw value labels
        ctx.textAlign = 'right';
        ctx.font = '10px sans-serif';
        ctx.fillStyle = '#6b7280';

        // Y-axis value labels
        for (let i = 0; i <= 5; i++) {
            const value = minValue + (i / 5) * valueRange;
            const y = height - padding - (i / 5) * plotHeight;
            ctx.fillText(value.toFixed(2), padding - 5, y + 3);
        }

        // X-axis value labels (showing data point indices)
        ctx.textAlign = 'center';
        for (let i = 0; i <= 5; i++) {
            const index = Math.round((i / 5) * (data.BLUE.length - 1));
            const x = padding + (i / 5) * plotWidth;
            ctx.fillText(index.toString(), x, height - padding + 15);
        }

    }

      getEvalModels(): void{
        this.setState({loading:true});
        this.props.dataHelper.CallSettingsService("GetEvalModels",{} ,{"studyId": this.props.studySelected.id} ,(dataOut: string)=>{
          let formattedOutput = JSON.parse(dataOut)  
          if (dataOut)
            {
              this.setState({
                modelsAvailable:formattedOutput,
                loading:false
              });
            }
        })
    }
      getFlowEval(useCurrentSelection: boolean = false): void{
        this.setState({loading:true});
        let segmentstart = 0;
        let segmentend = 0;
        if (useCurrentSelection)
        {
            segmentstart =  Math.trunc(this.props.scrollPositionInDatapoints?? 0);
            if (this.props.axisSizeInDatapoints)
            segmentend = (segmentstart + this.props.axisSizeInDatapoints) ? (segmentstart + this.props.axisSizeInDatapoints) : segmentstart + 1000;

        }
        this.props.dataHelper.CallSettingsService("GetEvalData",{} ,{studyId:this.props.studySelected.id, measurementId:this.props.rowData.id, procedureId:this.props.procedureId, measurementType:this.props.rowData.measurementType, modelname: this.state.modelSelected, customsegment: useCurrentSelection, segmentstart: segmentstart, segmentend: segmentend } ,(dataOut: string)=>{
          let formattedOutput = JSON.parse(dataOut)  
          if (dataOut)
            {
              this.setState({
                resultsloaded: true,
                loading:false,
              }, ()=>
              {
              let flowembedding = formattedOutput.flowembedding;
              let modelembedding = formattedOutput.modelembedding;
              this.drawEmbeddingPlot(modelembedding, flowembedding);
              this.drawFlowPlot(this.flowcanvasRef.current as HTMLCanvasElement, formattedOutput.flow, formattedOutput.segmenting);
              this.drawFlowPlot(this.processedflowcanvasRef.current as HTMLCanvasElement, formattedOutput.processedflow, formattedOutput.segmenting);
              });
            
              
            }
        })
    }

    canvasRef: React.RefObject<HTMLCanvasElement>;
    flowcanvasRef: React.RefObject<HTMLCanvasElement>;
    processedflowcanvasRef: React.RefObject<HTMLCanvasElement>;
    render() {

        
        return (
            
            <div>
              {this.state.loading ? <img  alt="Loading..." className="loadingImageMini" src="/Loading_orange.gif"></img>
              :
            (!this.state.modelsAvailable && !this.state.loading ?
             (
                <button className="thumbnailButton" onClick={()=>{
                    this.getEvalModels()
                }}>Load Models Available</button>
            ) : (
         
                <div>
                    <select className="modelSelect" value={this.state.modelSelected} onChange={(e)=>{
                        this.setState({modelSelected:e.target.value})
                    }}>
                        <option value="">Select Model</option>
                        {this.state.modelsAvailable?.map((modelName, index)=>(<option key={index} value={modelName}>{modelName}</option>))}
                    </select>
                </div>
            ))}

           
            {
                (this.state.modelSelected && !this.state.loading) && (
                  <>
                    <button className="thumbnailButton" onClick={()=>{
                        this.getFlowEval()
                    }}>Evaluate full flow</button>
                    <button className="thumbnailButton" onClick={()=>{
                        this.getFlowEval(true)
                    }}>Evaluate flow shown</button>
                    </>
                )
            }
             {
                this.state.resultsloaded && (
            <div>
               <div>
                <div>
                Original Flow
                </div>
                <div>
                <canvas
                                            ref={this.flowcanvasRef}
                                            width={500}
                                            height={200}
                                            className="border border-gray-300 rounded-lg shadow-sm"
                                        />
                                        </div>
            </div>
             <div>
              <div>
                Processed Flow
                </div>
                  <div>
              
                <canvas
                                            ref={this.processedflowcanvasRef}
                                            width={500}
                                            height={200}
                                            className="border border-gray-300 rounded-lg shadow-sm"
                                        />
                                        </div>
            </div>
            <div>
                <canvas
                                            ref={this.canvasRef}
                                            width={400}
                                            height={300}
                                            className="border border-gray-300 rounded-lg shadow-sm"
                                        />
            </div>
          </div>)}
            
            </div>
            
        );
    }
}
